import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ICompanyTypeModel } from '@apps-common/types/management/company'

export const getCompanyTypes = async (): Promise<ICompanyTypeModel[]> =>
  axios.get(`/management/company/getcompanytypes`).then((res) => res.data?.data)

type QueryFnType = typeof getCompanyTypes

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useManagementGetCompanyTypes = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: ['getCompanyTypes'],
    queryFn: () => getCompanyTypes()
  })
